import clsx from 'clsx';

import { Button as EditorButton } from '~components/generic/editor/Button/Button';
import { Panel } from '~components/generic/editor/Panel/Panel';
import { NewsletterIcon } from '~components/icons';
import { useNewsletter } from '~extension/changelog/hooks/useNewsletter';
import useLabels from '~hooks/useLabels';

export function Header() {
  const {
    btnNewsletterNew,
    btnNewsletterChooseItemsCancel,
    btnNewsletterChooseItemsConfirm,
    msgNewsletterChooseItems,
  } = useLabels([
    'btnNewsletterNew',
    'btnNewsletterChooseItemsCancel',
    'btnNewsletterChooseItemsConfirm',
    'msgNewsletterChooseItems',
  ]);
  const {
    canComposeNewsletter,
    isComposingNewsletter,
    startComposingNewsletter,
    cancelComposingNewsletter,
    openNewsletterDialog,
    selectedChangelogItemIds,
  } = useNewsletter();

  const hasSelectedItems = selectedChangelogItemIds.length > 0;

  if (!canComposeNewsletter) {
    return null;
  }

  if (isComposingNewsletter) {
    return (
      <Panel
        className={clsx('changelog-header--compose', 'flex justify-between items-center p-3 mb-4 sticky top-0 z-40')}
      >
        <div className={clsx('changelog-header--decription', 'flex-1')}>{msgNewsletterChooseItems}</div>
        <div className={clsx('changelog-header--actions', 'flex flex-nowrap ml-4')}>
          <EditorButton
            disabled={!hasSelectedItems}
            label={btnNewsletterChooseItemsConfirm}
            onClick={openNewsletterDialog}
            icon={<NewsletterIcon />}
          />
          <div className="mx-2" />
          <EditorButton label={btnNewsletterChooseItemsCancel} onClick={cancelComposingNewsletter} />
        </div>
      </Panel>
    );
  }

  return (
    <Panel className={clsx('changelog-header--new', 'flex justify-end items-center p-3 mb-4')}>
      <div className={clsx('changelog-header--actions', 'flex flex-nowrap ml-4')}>
        <EditorButton label={btnNewsletterNew} onClick={startComposingNewsletter} icon={<NewsletterIcon />} />
      </div>
    </Panel>
  );
}
